import React from "react";
import { Box, Typography } from "@mui/material";
import { FONT_SIZE } from "../../../constants/fontSizes";
import CompanyUserRow from "./CompanyUserRow";
import { TABLE_COLUMNS } from "./companyUserUtils";

// ヘッダーのスタイル
const headerCellSx = {
  fontSize: FONT_SIZE.SM,
  fontWeight: 600,
  color: "#6B7280",
};

// テーブルの列定義
const gridRowBaseSx = {
  display: "grid",
  gridTemplateColumns: TABLE_COLUMNS,
  gap: 2,
  alignItems: "center",
};

// ヘッダーのラベル
const HEADER_LABELS = ["氏名", "シメイ", "メールアドレス", "役割"];

/**
 * 担当者一覧表示
 *
 * 一覧の枠、ヘッダー、map 処理を担当する
 */
export default function CompanyUserList({
  companyId,
  visibleCompanyUsers,
  localErrors,
  onFieldChange,
  onRoleChange,
  onDeleteClick,
}) {
  return (
    <Box sx={{ width: "100%", minWidth: 0 }}>
      <Typography
        sx={{
          color: "#6B7280",
          fontSize: FONT_SIZE.SM,
          mb: 1,
        }}
      >
        担当者一覧（代表者含む・最大5名）
      </Typography>

      <Box
        sx={{
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          border: "1px solid #E5E7EB",
          backgroundColor: "#FFFFFF",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            ...gridRowBaseSx,
            px: 2,
            py: 1.25,
            backgroundColor: "#F7F8FA",
            borderBottom: "1px solid #E5E7EB",
          }}
        >
          {HEADER_LABELS.map((label) => (
            <Typography key={label} sx={headerCellSx}>
              {label}
            </Typography>
          ))}
        </Box>

        {visibleCompanyUsers.map((companyUser, index) => {
          const totalUsers = visibleCompanyUsers.length;
          const isLastRow = index === totalUsers - 1;

          return (
            <Box
              key={companyUser.id}
              sx={{
                ...gridRowBaseSx,
                px: 2,
                py: 1.5,
                minWidth: 0,
                borderBottom: isLastRow ? "none" : "1px solid #E5E7EB",
              }}
            >
              <CompanyUserRow
                companyId={companyId}
                companyUser={companyUser}
                localErrors={localErrors}
                visibleCompanyUsersLength={totalUsers}
                onFieldChange={onFieldChange}
                onRoleChange={onRoleChange}
                onDeleteClick={onDeleteClick}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
